module.exports = __webpack_public_path__ + "img/II-9.aea47f08.svg";